import React, { useEffect, useState } from 'react';
import DashboardLayout from './DashboardLayout';
import { Card, Row, Col, Button, Badge, Spinner, Alert } from 'react-bootstrap';
import { FaEnvelope, FaReply } from 'react-icons/fa';
import { API_BASE_URL } from '../services/api';
import { useAuth } from '../context/AuthContext';

const DashboardMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.id) {
      setLoading(false);
      return;
    }

    // Replace with your actual API endpoint
    fetch(`${API_BASE_URL}/get_messages.php?user_id=${user.id}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && Array.isArray(data.messages)) {
          setMessages(data.messages);
        } else {
          setMessages([]);
        }
        setLoading(false);
      })
      .catch(() => {
        setMessages([]);
        setLoading(false);
      });
  }, [user]);

  return (
    <DashboardLayout>
      <div>
        <h2 className="mb-4">Messages & Inquiries</h2>
        {loading ? (
          <div className="text-center my-5"><Spinner animation="border" /></div>
        ) : messages.length === 0 ? (
          <Alert variant="info">No messages or inquiries found.</Alert>
        ) : (
          <Row className="g-4">
            {messages.map(msg => (
              <Col md={6} key={msg.id}>
                <Card className="shadow-sm h-100">
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <Badge bg="secondary">{msg.business_name}</Badge>
                      <span className="text-muted small">{msg.created_at}</span>
                    </div>
                    <div className="mb-2">
                      <FaEnvelope className="me-2 text-primary" />
                      <span className="fw-bold">{msg.name}</span>
                      {msg.email && <span className="text-muted small ms-2">{msg.email}</span>}
                    </div>
                    <div className="mb-3">{msg.message}</div>
                    <div>
                      <Button
                        variant="outline-success"
                        size="sm"
                        disabled={!msg.email}
                        href={msg.email ? `mailto:${msg.email}` : undefined}
                      >
                        <FaReply className="me-1" /> Reply
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>
    </DashboardLayout>
  );
};

export default DashboardMessages; 